import gql from 'graphql-tag'

export const USUARIOS_PORTAL_PROPERTIES_QUERY = gql`
  query UsuariosPortalPropertiesQuery {
    usuariosPortalProperties {
      tiposUsuarioDocumentoObrigatorio {
        id
      }
      tiposUsuarioInformarCargo {
        id
      }
      tiposUsuarioInformarGestao {
        id
      }
      informarDepartamentoCargo
    }
  }
`
